/**
 * The template sheets of the open workspace (flag `templates`): the gallery, "Save as template" and their notices.
 * Mounted once by WorkspaceRoot; pages created from a template open in the current tab, "Edit template" opens the
 * template's page ("editing template" mode).
 */
import type { PageNode } from "@bundle/contracts";
import { Shell, type ShellViewModel, type TemplatesViewModel } from "@bundle/core";
import { SaveTemplateSheet, TemplateGallerySheet, TemplateNotice, useLocale, useViewModel } from "@bundle/ui";
import { useEffect } from "react";

export function TemplatesHost({ vm, shell, slug }: { vm: TemplatesViewModel; shell: ShellViewModel; slug: string }) {
  const state = useViewModel(vm);
  const locale = useLocale();
  // Built-in names and the content of new pages follow the app's language.
  useEffect(() => vm.setLocale(locale), [vm, locale]);
  const openPage = (page: PageNode) =>
    shell.open(page.kind === "database" ? Shell.formatUrl({ type: "db", ws: slug, dbId: page.id }) : Shell.formatUrl({ type: "page", ws: slug, pageId: page.id }));
  return (
    <>
      <TemplateGallerySheet
        vm={vm}
        state={state}
        onCreated={openPage}
        onEdit={(templateId) => {
          vm.close();
          shell.open(Shell.formatUrl({ type: "page", ws: slug, pageId: templateId }));
        }}
      />
      <SaveTemplateSheet vm={vm} state={state} />
      <TemplateNotice vm={vm} state={state} />
    </>
  );
}
